import React from 'react';
import { CTAButton } from './CTAButton';
export function BonusValue() {
  return <section className="bg-white py-12 px-4 sm:px-6" data-id="element-56">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-57">
        <div className="bg-brand-yellow p-8 rounded-3xl shadow-xl border-4 border-brand-black transform -rotate-1" data-id="element-58">
          <div className="text-5xl mb-4" data-id="element-59">🎁</div>
          <h3 className="font-archivo text-2xl sm:text-3xl uppercase text-brand-black mb-2" data-id="element-60">
            Valor estimado de los bonus:
          </h3>
          <div className="text-4xl sm:text-5xl font-archivo text-brand-red line-through mb-4" data-id="element-61">
            $67.000 ARS
          </div>
          <div className="text-2xl sm:text-3xl font-bold text-brand-black bg-white inline-block px-6 py-3 rounded-xl shadow-sm" data-id="element-62">
            👉 HOY VAN GRATIS CON TU COMPRA
          </div>
        </div>

        <div className="pt-8" data-id="element-63">
          <CTAButton text="🌱 QUIERO EL KIT COMPLETO" color="green" data-id="element-64" />
        </div>
      </div>
    </section>;
}